import { render, staticRenderFns } from "./IngredientItemStep.vue?vue&type=template&id=66ee40be&"
import script from "./IngredientItemStep.vue?vue&type=script&lang=js&"
export * from "./IngredientItemStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports